import React from "react";
import { store, commonState } from "../../../store";
import { Switch } from "react-materialize";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { selectShiftReports } from "../../../services/shift_monitoring/shift_select/shift_reports";
import {
    selectShiftOffice,
    selectDriver,
    selectStartDate,
    selectEndDate,
    selectNeedGuidance,
} from "../../../services/shift_monitoring/shift_select/select_shift";
import { DriversList, DriversRow } from "../../../api";
import { MonthDayPicker } from "../../../components/datepickers/MonthDayPicker";
import { ShiftSearchTable, Props } from "./Table";
import { OfficePullDown } from "../../../components/officePullDown";
import { DriverPulldown } from "../../../components/driverPulldown";
import { fontSizes } from "../../../theme";

interface SearchBarProps {
    commonState: commonState;
    selectedOfficeId?: number;
}

const SearchBar: React.FC<SearchBarProps> = (props: SearchBarProps) => {
    const click_search = (ev: any) => {
        selectShiftReports();
    };

    const set_start_date = (ev: any) => {
        selectStartDate(ev as string);
    };

    const set_end_date = (ev: any) => {
        selectEndDate(ev as string);
    };

    const set_guidance_selected = (ev: any) => {
        selectNeedGuidance(ev.target.checked);
    };

    function onChangeDriver(driver: DriversRow | null) {
        selectDriver(driver);
    }

    const onClearDriver = () => {
        selectDriver(null);
    };

    return (
        <Box
            id="SearchBarContainer"
            sx={{ p: 2, display: "flex", alignItems: "end" }}
        >
            <Box>
                <OfficePullDown
                    useAllOfficeIds={true}
                    selectedOfficeId={props.selectedOfficeId}
                    onChange={selectShiftOffice}
                />
            </Box>
            <Box sx={{ pl: 3 }}>
                <DriverPulldown
                    selectedDriver={props.commonState.selectedDriver}
                    onChange={onChangeDriver}
                    onClear={onClearDriver}
                    driverCompleteData={props.commonState.driverNames}
                    initWithNull={false}
                />
            </Box>
            <Box
                sx={{
                    pl: 3,
                }}
            >
                <MonthDayPicker
                    initialDate={store.getState().shifts.startDate}
                    onChangeMethod={(ev) => {
                        set_start_date(ev);
                    }}
                />
            </Box>
            <Box sx={{ pr: 3, pl: 3, pb: 1.5, fontSize: fontSizes.xxlarge }}>
                ~
            </Box>
            <Box>
                <MonthDayPicker
                    initialDate={store.getState().shifts.endDate || ""}
                    onChangeMethod={(ev) => {
                        set_end_date(ev);
                    }}
                />
            </Box>
            <Box style={{ margin: "3px" }}>
                <Button
                    variant="contained"
                    onClick={async (ev) => {
                        set_end_date(null);
                    }}
                    color="info"
                    size="small"
                >
                    クリア
                </Button>
            </Box>
            <Box style={{ padding: "10px", display: "inline-block" }}>
                <Switch
                    onChange={(ev) => {
                        set_guidance_selected(ev);
                    }}
                    id="checked-search-check"
                    onLabel="要指導あり"
                    offLabel=""
                    checked={store.getState().shifts.needGuidanceOnly}
                />
            </Box>
            <Box sx={{ pl: 4 }}>
                <Button
                    variant="contained"
                    onClick={async (ev) => {
                        click_search(ev);
                    }}
                    color="primary"
                    size="medium"
                >
                    検索
                </Button>
            </Box>
        </Box>
    );
};

export const SearchScreen: React.FC<Props> = (props: Props) => {
    const componentDidMount = () => {
        const _i = document.getElementsByClassName("autocomplete");
        const inpts = [...(_i as any)];
        inpts.forEach((el: HTMLInputElement) => {
            el.autocomplete = "off";
        });
    };

    componentDidMount();

    return (
        <Box>
            <SearchBar
                commonState={props.commonState}
                selectedOfficeId={props.shifts.officeId}
            />
            <ShiftSearchTable
                commonState={props.commonState}
                shifts={props.shifts}
            />
        </Box>
    );
};
